export default "__VITE_ASSET__CoEU_gi9__"